import { Markdown } from "../markdown";
import type { ComponentProps } from "./index";
import { useWorkspaceText } from "./useWorkspaceJson";

/**
 * Renders `{ paths, title? }`: workspace files, each folded under its path, closed on arrival. A
 * reply that names a file shows it this way, because a link to a workspace path cannot be followed
 * from the chat. Fetched through the workspace route, so what is shown is the file as it is now.
 */
export function Files({ sessionId, args }: ComponentProps): React.ReactNode {
	const paths = Array.isArray(args.paths) ? args.paths.filter((p): p is string => typeof p === "string" && p.trim() !== "") : [];
	const title = typeof args.title === "string" ? args.title : undefined;
	if (paths.length === 0) return <div className="component error">show_files 缺少 paths 参数，收到的参数：{JSON.stringify(args)}</div>;
	return (
		<div className="component draft-component">
			{title && <div className="document-title">{title}</div>}
			{paths.map((p) => (
				<details key={p} className="draft-file">
					<summary>
						<code>{p}</code>
					</summary>
					<FileBody sessionId={sessionId} source={p} />
				</details>
			))}
		</div>
	);
}

function FileBody({ sessionId, source }: { sessionId: string; source: string }) {
	const { data, error, loading } = useWorkspaceText(sessionId, source);
	if (error) return <p className="error">{error}</p>;
	if (loading || data === null) return <p className="hint">加载中…</p>;
	if (source.toLowerCase().endsWith(".md")) return <Markdown text={data} />;
	return <pre>{data}</pre>;
}
